<script>
import { modalState, showModal} from "@app/store/modalStore.svelte.js";
import {
    pedalState,
    PEDAL_SOURCES,
    togglePedalControl,
    startPedalControl,
    savePedalSettings,
} from '@app/store/pedalStore.svelte.js';
import { environment } from "@app/store/envStore.svelte.js";
import { setExternalDataState } from "@app/store/externalDataStore.svelte.js";
import { getDeepLinkTarget, getHandoffPreference } from "@app/lib/desktopHandoff.js";
import { projectState } from "@app/store/projectStore.svelte.js";
import { hasUnsavedChanges } from "@app/store/historyStore.svelte.js";
import { uiState } from "@app/store/uiStore.svelte.js";
import { authState, setAuth } from "@app/store/authStore.svelte.js";
import { loadListFromDb } from "@app/store/autoReplaceStore.svelte.js";
import { loadPresets } from "@app/store/presetStore.svelte.js";
import { initTeamWatermark } from "@app/store/watermarkStore.svelte.js";
import { toast } from "@zerodevx/svelte-toast";
import Swal from "sweetalert2";
import { SWAL_BASE, SWAL_CLASSES } from "@app/lib/swalClasses.js";
import { auth, functions } from "@app/configs/firebase.js";
import { httpsCallable } from "firebase/functions";
import { replace } from "svelte-spa-router";
import { Pane, Splitpanes } from "svelte-splitpanes";
import ToolbarPrimary from "../components/toolbar/ToolbarPrimary.svelte";
import ToolbarSecondary from "../components/toolbar/ToolbarSecondary.svelte";
import Player from "../components/player/Player.svelte";
import QuickTools from "../components/quickTools/QuickTools.svelte";
import PlayerControls from "../components/player/PlayerControls.svelte";
import Editor from "../components/editor/Editor.svelte";
import Timeline from "../components/timeline/konva/Timeline.svelte";
import { initAppTheme } from "@app/store/themeStore.svelte.js";
import { loadSystemTheme } from "@app/lib/theme/themeLoader.js";
import AboutModal from "../components/modals/About.svelte";
import EventGroupOptionsModal from "../components/modals/EventGroupOptions.svelte";
import PasteAttributesModal from "../components/modals/PasteAttributes.svelte";
import UsageModal from "../components/modals/Usage.svelte";
import SnapshotHistoryModal from "../components/modals/SnapshotHistory.svelte";
import AiTranscriptImportModal from "../components/modals/AiTranscriptImport.svelte";
import AiTranslationImportModal from "../components/modals/AiTranslationImport.svelte";
import AudioDescriptionExportModal from "../components/modals/AudioDescriptionExport.svelte";
import AudioDubbingExportModal from "../components/modals/AudioDubbingExport.svelte";
import AudioEmbedExportModal from "../components/modals/AudioEmbedExport.svelte";
import AutomaticTranscriptionModal from "../components/modals/AutomaticTranscription.svelte";
import BatchTranscriptionModal from "../components/modals/BatchTranscription.svelte";
import AutomaticTranslationModal from "../components/modals/AutomaticTranslation.svelte";
import AutomaticAdModal from "../components/modals/AutomaticAd.svelte";
import AiAdImportModal from "../components/modals/AiAdImport.svelte";
import AutomaticSceneDescriptionsModal from "../components/modals/AutomaticSceneDescriptions.svelte";
import AiSceneDescriptionImportModal from "../components/modals/AiSceneDescriptionImport.svelte";
import FileExportModal from "../components/modals/FileExport.svelte";
import FileImportModal from "../components/modals/FileImport.svelte";
import MarkerImportModal from "../components/modals/MarkerImport.svelte";
import MediaImportModal from "../components/modals/MediaImport.svelte";
import AudioStemsModal from "../components/modals/AudioStems.svelte";
import MusicNotesModal from "../components/modals/MusicNotes.svelte";
import InsertSpeakerModal from "../components/modals/InsertSpeaker.svelte";
import NewEventGroupModal from "../components/modals/NewEventGroup.svelte";
import EditEventGroupModal from "../components/modals/EditEventGroup.svelte";
import MergeEventGroupModal from "../components/modals/MergeEventGroup.svelte";
import TranslationMergeModal from "../components/modals/TranslationMerge.svelte";
import MetadataMergeModal from "../components/modals/MetadataMerge.svelte";
import SegmentEventGroupModal from "../components/modals/SegmentEventGroup.svelte";
import NewProjectModal from "../components/modals/NewProject.svelte";
import OptionsModal from "../components/modals/Options.svelte";
import PlainTextImportModal from "../components/modals/PlainTextImport.svelte";
import ProjectTimingSettingsModal from "../components/modals/ProjectTimingSettings.svelte";
import ConvertTimecodeModal from "../components/modals/ConvertTimecode.svelte";
import GoToEventModal from "../components/modals/GoToEvent.svelte";
import OfflineActivationModal from "../components/modals/OfflineActivation.svelte";
import ShortcutKeysModal from "../components/modals/ShortcutKeys.svelte";
import SubtitleExportModal from "../components/modals/SubtitleExport.svelte";
import EmbedCaptionsExportModal from "../components/modals/EmbedCaptionsExport.svelte";
import CcslExportModal from "../components/modals/CcslExport.svelte";
import DialogueListExportModal from "../components/modals/DialogueListExport.svelte";
import BatchSubtitleExportModal from "../components/modals/BatchSubtitleExport.svelte";
import SubtitleImportModal from "../components/modals/SubtitleImport.svelte";
import TranslationImportModal from "../components/modals/TranslationImport.svelte";
import ProjectImportModal from "../components/modals/ProjectImport.svelte";
import ProjectInfoModal from "../components/modals/ProjectInfoModal.svelte";
import TcOffsetModal from "../components/modals/TcOffset.svelte";
import BlankFramesModal from "../components/modals/BlankFrames.svelte";
import SnapToShotChangesModal from "../components/modals/SnapToShotChanges.svelte";
import TimeStretchModal from "../components/modals/TimeStretch.svelte";
import TranscriptExportModal from "../components/modals/TranscriptExport.svelte";
import VideoExportModal from "../components/modals/VideoExport.svelte";
import ImageExportModal from "../components/modals/ImageExport.svelte";
import WelcomeModal from "../components/modals/Welcome.svelte";
import ZoomModal from "../components/modals/Zoom.svelte";
import SpeakerManager from "../components/modals/SpeakerManager.svelte";
import TagsManager from "../components/modals/TagsManager.svelte";
import RemoveSdhModal from "../components/modals/RemoveSdh.svelte";
import StorageExplorerModal from "../components/modals/StorageExplorer.svelte";
import TeamProjectImportModal from "../components/modals/TeamProjectImport.svelte";
import TeamShareModal from "../components/modals/TeamShare.svelte";
import TeamSyncModal from "../components/modals/TeamSync.svelte";
import EventGroupSyncModal from "../components/modals/EventGroupSync.svelte";
import RenderAudioModal from "../components/modals/RenderAudio.svelte";
import AudioRecorderModal from "../components/modals/AudioRecorder.svelte";
import AutoFormatModal from "../components/modals/AutoFormat.svelte";
import AutoCorrectTimingModal from "../components/modals/AutoCorrectTiming.svelte";
import TimingAndSyncSettingsModal from "../components/modals/TimingAndSyncSettings.svelte";
import LiveCaptionSettingsModal from "../components/modals/LiveCaptionSettings.svelte";
import CaptionStyleModal from "../components/modals/CaptionStyle.svelte";
import CaptionPositionModal from "../components/modals/CaptionPosition.svelte";
import DrasticTechModal from "../components/modals/DrasticTech.svelte";
import AutomaticSaveModal from "../components/modals/AutomaticSave.svelte";
import CopyTcFromGroupModal from "../components/modals/CopyTcFromGroup.svelte";
import CopyEventTextModal from "../components/modals/CopyEventText.svelte";
import SplitMultiviewGroupModal from "../components/modals/SplitMultiviewGroup.svelte";
import TipsModal from "../components/modals/Tips.svelte";
import VoiceManagerModal from "../components/modals/VoiceManager.svelte";
import SceneChangeDetectionModal from "../components/modals/SceneChangeDetection.svelte";
import PreRenderFrameCacheModal from "../components/modals/PreRenderFrameCache.svelte";
import OfflineTranscriptionModal from "../components/modals/OfflineTranscription.svelte";
import OfflineSyncModal from "../components/modals/OfflineSync.svelte";
import OcrMediaModal from "../components/modals/OcrMedia.svelte";
import LoadProjectFileModal from "../components/modals/LoadProjectFile.svelte";
import AutoReplaceModal from "../components/modals/AutoReplace.svelte";
import TeamManagerModal from "../components/modals/TeamManager.svelte";
import PresetManagerModal from "../components/modals/PresetManager.svelte";
import IconikGetProxyModal from "../components/modals/IconikGetProxy.svelte";
import IconikImportModal from "../components/modals/IconikImport.svelte";
import IconikPublishModal from "../components/modals/IconikPublish.svelte";
import IconikMetadataModal from "../components/modals/IconikMetadata.svelte";
import IFrameRemoteModal from "../components/modals/IFrameRemote.svelte";
import AteliereConnectRemoteModal from "../components/modals/AteliereConnectRemote.svelte";
import WorkOrderImportModal from "../components/modals/WorkOrderImport.svelte";
import OpenInDesktopModal from "../components/modals/OpenInDesktop.svelte";
import WorkOrderPublishModal from "../components/modals/WorkOrderPublish.svelte";
import EventGroupMetadataModal from "../components/modals/EventGroupMetadata.svelte";
import StyleGuideManager from "../components/modals/StyleGuideManager.svelte";
import CompareEventGroupsModal from "../components/modals/CompareEventGroups.svelte";
import KnpManager from "../components/modals/KnpManager.svelte";
import SubscriptionManagement from "../components/modals/SubscriptionManagement.svelte";
import KnpLookup from "../components/offcanvas/KnpLookup.svelte";
import DesktopBanner from "@app/components/DesktopBanner.svelte";
import { SvelteToast } from "@zerodevx/svelte-toast";
import * as m from "@app/paraglide/messages.js";

const ipcRenderer = window.ipcRenderer;
const supportEmail = "support@closedcaptioncreator.com";
let userId = $state();
let email = $state();
let failureCount = 0;

if (environment.online) {
    userId = auth.currentUser.uid;
    email = auth.currentUser.email;
} else if (environment.iframe) {
    console.log("IFrame Mode Enabled");
} else {
    console.log("Offline Mode Enabled");
}

initAppTheme();
loadSystemTheme(environment.system);

let projectFilePath = $state();
let hideTips = $state(true);
let timelineHeight = $state(150);
let editorHeight = $state(820);
let canUseAudioDescription = $derived(authState.ad || !environment.online);

/* Map a validated deep link payload from the main process onto the same
   external-data + modal flow the web build uses for /iconik, /workorder and
   /share. Returns true when the link was handled. */
function applyDeepLink(deepLink) {
    if (!deepLink || !deepLink.route) {
        return false;
    }

    if (!environment.online) {
        /* All three import modals are gated on environment.online, so honouring
           the link on an offline build would render nothing at all. */
        console.warn("Ignoring deep link: this build is offline only.");
        toast.push(m.open_in_desktop_requires_online());
        return false;
    }

    if (deepLink.route === "iconik" && deepLink.asset_ids) {
        setExternalDataState({
            platform: "Iconik",
            status: "importing",
            assetId: deepLink.asset_ids,
        });
        showModal("iconikImport");
        return true;
    } else if (deepLink.route === "workorder" && deepLink.description) {
        setExternalDataState({
            platform: "Work Order",
            status: "importing",
            rawDescription: deepLink.description,
        });
        showModal("workOrderImport");
        return true;
    } else if (deepLink.route === "share" && deepLink.id) {
        /* No "platform" here: TeamProjectImport doesn't set one on the browser
           path either, and nothing reads a "Team Project" value. */
        setExternalDataState({
            status: "importing",
            shareCode: deepLink.id,
        });
        showModal("teamProjectImport");
        return true;
    }

    return false;
}

async function setup() {
    try {
        if (environment.iframe && !environment.online) {
            if (environment.system === "ateliere") {
                showModal("ateliereConnectRemote");
            }

            return;
        } else if (environment.electron) {
            window.__ccHasUnsavedChanges = () => hasUnsavedChanges();

            /* A "closedcaptioncreator://" link the user opened in their browser.
               Checked before getProjectFilePath because it is the more explicit
               gesture; in practice the two are mutually exclusive, since a deep
               link launch never carries a ".ccprj" argument. */
            let deepLink = null;
            try {
                deepLink = await ipcRenderer.invoke("getPendingDeepLink");
            } catch (err) {
                /* Older main.js without the channel: carry on as before. */
                console.warn("Deep link channel unavailable: " + err?.message);
            }

            if (deepLink && applyDeepLink(deepLink)) {
                return;
            }

            projectFilePath = await ipcRenderer.invoke("getProjectFilePath");

            if (projectFilePath) {
                console.log("Project File Path: " + projectFilePath);
                showModal("loadProjectFile");
            } else {
                hideTips = localStorage.getItem("cc-hide-v50");
                if (hideTips && (hideTips === "true" || hideTips === true)) {
                    showModal("welcome");
                } else {
                    showModal("tips");
                }
            }
        } else {
            if (!window.litHtmlVersions) {
                // Warn only when there are unsaved edits since the last load/save baseline.
                window.onbeforeunload = function () {
                    if (hasUnsavedChanges()) {
                        return m.creator_before_unload_confirm();
                    }
                };
            }
            console.info(
                "DEBUG: Parsing URL params from URL: " + window.location.href,
            );
            let urlString = window.location.href;
            let url = new URL(urlString);

            // Check for checkout success
            const checkoutStatus = url.searchParams.get("checkout");
            if (checkoutStatus === "success") {
                // Handle successful checkout with retry logic
                await handleCheckoutSuccess();
                return;
            }

            /* Offer the installed desktop app before starting a browser import.
               environment.electron is true in packaged AND dev Electron (the
               renderer has nodeIntegration, so platform-detect sees
               process.versions.electron), so this can never fire inside the
               desktop app itself. */
            const deepLinkTarget = getDeepLinkTarget(urlString);
            if (
                deepLinkTarget &&
                !environment.electron &&
                !environment.iframe &&
                getHandoffPreference() !== "browser"
            ) {
                showModal("openInDesktop");
                return;
            }

            if (url.pathname && url.pathname.includes("iconik")) {
                showModal("iconikImport");
                return;
            } else if (url.pathname && url.pathname.includes("workorder")) {
                showModal("workOrderImport");
                return;
            } else if (url.pathname && url.pathname.includes("share")) {
                showModal("teamProjectImport");
                return;
            }

            hideTips = localStorage.getItem("cc-hide-v50");
            if (hideTips && (hideTips === "true" || hideTips === true)) {
                showModal("welcome");
            } else {
                showModal("tips");
            }
        }
    } catch (err) {
        console.log("Setup Script Failed");
        console.log(err, err.message);
    }
}

/* Handle Checkout Success with Retry Logic */
async function handleCheckoutSuccess() {
    // Show loading dialog
    Swal.fire({
        ...SWAL_BASE,
        title: m.creator_checkout_verifying_title(),
        text: m.creator_checkout_verifying_text(),
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
            Swal.showLoading();
        }
    });

    const maxRetries = 3;
    let retryCount = 0;
    let success = false;

    // Initial wait of 5 seconds
    await new Promise(resolve => setTimeout(resolve, 5000));

    // Retry loop
    while (retryCount < maxRetries && !success) {
        try {
            const authSuccess = await authCheck();
            if (authSuccess) {
                success = true;
                break;
            }
        } catch (error) {
            console.log(`Auth check attempt ${retryCount + 1} failed:`, error);
        }

        retryCount++;
        
        if (retryCount < maxRetries) {
            // Wait 3 seconds before next retry
            await new Promise(resolve => setTimeout(resolve, 3000));
        }
    }

    // Close loading dialog
    Swal.close();

    if (success) {
        // Clear the checkout query parameter
        window.history.replaceState({}, "", window.location.pathname);
        
        // Show success message
        toast.push(m.creator_checkout_verified_toast(), {
            classes: ["toast-success"]
        });

        // Continue with normal setup flow
        hideTips = localStorage.getItem("cc-hide-v50");
        if (hideTips && (hideTips === "true" || hideTips === true)) {
            showModal("welcome");
        } else {
            showModal("tips");
        }
    } else {
        // Show error and redirect to signup
        await Swal.fire({
            ...SWAL_BASE,
            customClass: SWAL_CLASSES.ok,
            title: m.creator_checkout_verification_failed_title(),
            text: m.creator_checkout_verification_failed_text({ email: supportEmail }),
            icon: "error",
            confirmButtonText: m.creator_checkout_return_to_signup(),
            allowOutsideClick: false,
            allowEscapeKey: false,
        });
        
        replace("/signup");
    }
}

/* Init Foot Pedal and other Device Controllers */
async function initExtControl() {
    if (!pedalState.enable) {
        return;
    }

    const source = pedalState.source || PEDAL_SOURCES.WEBHID;

    // WebHID needs a user gesture for requestDevice / reopen flows
    if (source === PEDAL_SOURCES.WEBHID) {
        Swal.fire({
            ...SWAL_BASE,
            customClass: SWAL_CLASSES.confirmCancelLight,
            titleText: m.creator_ext_device_title(),
            text: m.creator_ext_device_prompt(),
            icon: "question",
            showCancelButton: true,
            confirmButtonText: m.creator_ext_device_confirm(),
            cancelButtonText: m.creator_ext_device_cancel(),
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    // User gesture from dialog; open picker only if no granted devices yet
                    await togglePedalControl(true);
                    toast.push(m.creator_ext_device_enabled_toast(), {
                        classes: ["toast-success"],
                    });
                } catch (err) {
                    console.error(err);
                    toast.push(err?.message || String(err), {
                        classes: ["toast-error"],
                    });
                }
            } else {
                pedalState.enable = false;
                savePedalSettings();
                toast.push(m.creator_ext_device_disabled_toast(), {
                    classes: ["toast-info"],
                });
            }
        });
        return;
    }

    // vPedal Browser API / Gamepad — no HID permission prompt
    try {
        await startPedalControl();
        toast.push(m.creator_ext_device_enabled_toast(), {
            classes: ["toast-success"],
        });
    } catch (err) {
        console.error(err);
        toast.push(err?.message || String(err), {
            classes: ["toast-error"],
        });
    }
}

async function authCheck() {
    try {
        let subscription, ad = false;
        // console.log("----------AUTH CHECK-----------");
        if (environment.iframe && !environment.online) {  
            return true;
        } else if (environment.online) {
            let getAuthInfoRes = await httpsCallable(functions, "v8UserAuthV3")(email);

            /* Debug */
            // console.log("AUTH RES:");
            // console.log(JSON.stringify(getAuthInfoRes, null, 4));

            let subscriptionList = getAuthInfoRes.data.subscriptions.list;
            if (subscriptionList.length === 0) {
                throw new Error("Subscription does not exist");
            }

            //console.log(JSON.stringify(subscriptionList, null, 4));
            subscriptionList.forEach((subItem) => {
                if (/unlimited/.test(subItem.subscription.plan_id)) {
                    subscription = {
                        subId: subItem.subscription.id,
                        uid: subItem.customer.id,
                        plan: "pro",
                        type: "unlimited",
                        status: subItem.subscription.status,
                        ad: false,
                    };
                } else if (/pro/.test(subItem.subscription.plan_id)) {
                    subscription = {
                        subId: subItem.subscription.id,
                        uid: subItem.customer.id,
                        plan: "pro",
                        type: "default",
                        status: subItem.subscription.status,
                        ad: false,
                    };
                } else if (/enterprise/.test(subItem.subscription.plan_id)) {
                    subscription = {
                        subId: subItem.subscription.id,
                        uid: subItem.customer.id,
                        plan: "enterprise",
                        type: "default",
                        status: subItem.subscription.status,
                        ad: false,
                    };
                } else if (
                    !subscription &&
                    /starter/.test(subItem.subscription.plan_id)
                ) {
                    subscription = {
                        subId: subItem.subscription.id,
                        uid: subItem.customer.id,
                        plan: "starter",
                        type: "default",
                        status: subItem.subscription.status,
                        ad: false,
                    };
                }
                
                if (subItem.subscription.addons) {
                    subItem.subscription.addons.forEach((addOn) => {
                        if (/ad/.test(addOn.id)) {
                            ad = true;
                        }
                    });
                }
            });

            if (subscription) {
                subscription.ad = ad;
                subscription.owner = getAuthInfoRes.data.owner;
                subscription.ownerId = getAuthInfoRes.data.ownerId;
                subscription.team = getAuthInfoRes.data.team;
                subscription.user = getAuthInfoRes.data.user;
                subscription.ipAddress = getAuthInfoRes.data.ipAddress || null;
                setAuth(subscription);
                initTeamWatermark();
                loadListFromDb(userId);
                loadPresets(userId);
                console.log(`✓ AUTH CHECK SUCCESS`);
            } else {
                throw new Error("X Subscription does not exist");
            }

            return true;
        } else if (!environment.online && !environment.iframe) {
            let activationCode = localStorage.getItem("cc-offline-license");
            let licenseInfo = await ipcRenderer.invoke(
                "licenseCheck",
                activationCode,
            );
            if (licenseInfo.active) {
                subscription = {
                    user: "Offline",
                    owner: "Offline",
                    ownerId: "Offline",
                    team: "Offline",
                    subId: "Offline",
                    uid: "Offline",
                    plan: licenseInfo.plan,
                    type: "default",
                    status: "active",
                    ad: licenseInfo.ad,
                };

                setAuth(subscription);
                loadListFromDb();
                loadPresets();
                return true;
            } else {
                toast.push(m.creator_offline_license_invalid_toast(), {
                    classes: ["toast-danger"],
                });

                localStorage.removeItem("cc-offline-license");
                console.log(licenseInfo);
                replace("/loginOffline");
                return false;
            }
        } else {
            replace("/offline");
            return false;
        }

        
    } catch (err) {
        console.error(err, err.message);
        if (environment.online) {           
            Swal.fire({
                ...SWAL_BASE,
                customClass: SWAL_CLASSES.ok,
                titleText: m.creator_auth_error_title(),
                html: m.creator_auth_error_subscription_html(),
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: m.common_continue(),
                allowOutsideClick: false,
                allowEscapeKey: false,
            }).then((result) => {
                // Redirect to signup page without signing out
                replace("/signup");
                return false;
            });
        } else {
            /* Offline code here */
            localStorage.removeItem("cc-offline-license");
            setTimeout(() => {
                replace("/loginOffline");
            }, 2000);

            Swal.fire({
                ...SWAL_BASE,
                customClass: SWAL_CLASSES.ok,
                titleText: m.creator_auth_error_title(),
                text: m.creator_auth_error_license_text({ message: err.message, email: supportEmail }),
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: m.ok(),
                allowOutsideClick: false,
                allowEscapeKey: false,
            }).then((result) => {
                // console.log(result);
                localStorage.removeItem("cc-offline-license");
                replace("/loginOffline");
            });
        }
    }
}

function handleResize(ev) {
    let totalHeight = window.innerHeight * 0.94;

    /* Ready */
    if (!ev.detail) {
        if (
            uiState.layout === "default" ||
            uiState.layout === "reverse" ||
            uiState.layout === "ultrawide"
        ) {
            editorHeight = totalHeight * (84.5 / 100) - 90;
            timelineHeight = totalHeight * (15 / 100);
        } else if (uiState.layout === "vertical") {
            editorHeight = totalHeight * (39.5 / 100) - 90;
            timelineHeight = totalHeight * (20 / 100);
        }

        return;
    }

    /* Resize */
    if (
        uiState.layout === "default" ||
        uiState.layout === "reverse" ||
        uiState.layout === "ultrawide"
    ) {
        if (uiState.timeline) {
            editorHeight = totalHeight * ((ev.detail[0].size - 0.5) / 100) - 90;
            timelineHeight = totalHeight * (ev.detail[1].size / 100);
        } else {
            editorHeight = totalHeight * ((ev.detail[0].size - 0.5) / 100) - 90;
            timelineHeight = 0;
        }
    } else if (uiState.layout === "vertical") {
        editorHeight = totalHeight * ((ev.detail[1].size - 0.5) / 100) - 90;
        if (uiState.timeline) {
            timelineHeight = totalHeight * (ev.detail[2].size / 100);
        }
    }
}

function handleComponentError(err) {
    console.log("----Component boundary error captured----");
    console.warn(err);    
    uiState.timeline = false;

    setTimeout(() => {
        if (failureCount < 5){
            uiState.timeline = true;
        }        
    }, 1000);

    failureCount++;
    console.log("-------------------");
}

setup();
authCheck();
initExtControl();
</script>

<!-- HTML TEMPLATE -->
<DesktopBanner />
<SvelteToast
    options={{
        duration: 1500,
        pausable: true,
        dismissable: true,
        reversed: true,
        intro: { y: 64 },
    }} />

<ToolbarPrimary />

    <ToolbarSecondary />


<!-- DEFAULT LAYOUT -->
{#if uiState.layout === "default"}
    <Splitpanes
        horizontal={true}
        style="height: 94vh;"
        on:resized={handleResize}
        on:ready={handleResize}>
        <Pane>
            <Splitpanes>
                <Pane class={"p-2"} size={40}>
                    <svelte:boundary onerror={handleComponentError}>
                        <Player />
                    </svelte:boundary>
                    <svelte:boundary onerror={handleComponentError}>
                        <PlayerControls />
                    </svelte:boundary>
                    <svelte:boundary onerror={handleComponentError}>
                        <QuickTools />
                    </svelte:boundary>
                </Pane>
                <Pane class={"p-2"}>
                    <svelte:boundary onerror={handleComponentError}>
                        
                            <Editor {editorHeight} />
                                                
                    </svelte:boundary>
                </Pane>
            </Splitpanes>
        </Pane>

        {#if uiState.timeline}
            <Pane size={15}>
                <svelte:boundary onerror={handleComponentError}>
                    <Timeline {timelineHeight} />
                </svelte:boundary>
            </Pane>
        {/if}
    </Splitpanes>

    <!-- DEFAULT REVERSE LAYOUT -->
{:else if uiState.layout === "reverse"}
    <Splitpanes
        horizontal={true}
        style="height: 94vh;"
        on:resized={handleResize}
        on:ready={handleResize}>
        <Pane>
            <Splitpanes>
                <Pane class={"p-2"}>
                    <svelte:boundary onerror={handleComponentError}>
                        
                            <Editor {editorHeight} />
                        
                    </svelte:boundary>
                </Pane>

                <Pane class={"p-2"} size={40}>
                    <svelte:boundary onerror={handleComponentError}>
                        <Player />
                    </svelte:boundary>
                    <svelte:boundary onerror={handleComponentError}>
                        <PlayerControls />
                    </svelte:boundary>
                    <svelte:boundary onerror={handleComponentError}>
                        <QuickTools />
                    </svelte:boundary>
                </Pane>
            </Splitpanes>
        </Pane>

        {#if uiState.timeline}
            <Pane size={15}>
                <svelte:boundary onerror={handleComponentError}>
                    <Timeline {timelineHeight} />
                </svelte:boundary>
            </Pane>
        {/if}
    </Splitpanes>

    <!-- ULTRAWIDE LAYOUT -->
{:else if uiState.layout === "ultrawide"}
    <Splitpanes
        horizontal={true}
        style="height: 94vh;"
        on:resized={handleResize}
        on:ready={handleResize}>
        <Pane>
            <Splitpanes>
                <Pane class={"p-2"} size={40}>
                    <svelte:boundary onerror={handleComponentError}>
                        <Player />
                    </svelte:boundary>
                    <svelte:boundary onerror={handleComponentError}>
                        <PlayerControls />
                    </svelte:boundary>
                </Pane>
                <Pane class={"p-2"}>
                    <svelte:boundary onerror={handleComponentError}>
                        
                            <Editor {editorHeight} />
                        
                    </svelte:boundary>
                </Pane>
                <Pane class={"p-2"} size={40}>
                    <svelte:boundary onerror={handleComponentError}>
                        <QuickTools />
                    </svelte:boundary>
                </Pane>
            </Splitpanes>
        </Pane>
        {#if uiState.timeline}
            <Pane size={15}>
                <svelte:boundary onerror={handleComponentError}>
                    <Timeline {timelineHeight} />
                </svelte:boundary>
            </Pane>
        {/if}
    </Splitpanes>

    <!-- Vertical LAYOUT -->
{:else if uiState.layout === "vertical"}
    <Splitpanes
        id={"mainPane"}
        horizontal={true}
        style="height: 94vh;"
        on:resized={handleResize}
        on:ready={handleResize}>
        <Pane class={"p-2"} size={40}>
            <Splitpanes>
                <Pane class={"p-2"}>
                    <svelte:boundary onerror={handleComponentError}>
                        <Player />
                    </svelte:boundary>
                    <svelte:boundary onerror={handleComponentError}>
                        <PlayerControls />
                    </svelte:boundary>
                </Pane>

                <Pane class={"p-2"}>
                    <svelte:boundary onerror={handleComponentError}>
                        <QuickTools />
                    </svelte:boundary>
                </Pane>
            </Splitpanes>
        </Pane>

        <Pane class={"p-2"} size={40}>
            <svelte:boundary onerror={handleComponentError}>
                
                    <Editor {editorHeight} />
                
            </svelte:boundary>
        </Pane>

        {#if uiState.timeline}
            <Pane size={20}>
                <svelte:boundary onerror={handleComponentError}>
                    <Timeline {timelineHeight} />
                </svelte:boundary>
            </Pane>
        {/if}
    </Splitpanes>
{/if}
<!-- MODALS -->
<!-- Always load the shortcut keys and auto save modal -->
<svelte:boundary onerror={handleComponentError}>
    <ShortcutKeysModal />
</svelte:boundary>
{#if !environment.iframe}
    <svelte:boundary onerror={handleComponentError}>
        <AutomaticSaveModal />
    </svelte:boundary>
{:else if environment.iframe && !environment.online}
    <svelte:boundary onerror={handleComponentError}>
        {#if environment.system === "ateliere"}
            <AteliereConnectRemoteModal />
        {:else}
            <IFrameRemoteModal />
        {/if}
    </svelte:boundary>
{/if}

{#if modalState.selected === "about"}
    <svelte:boundary onerror={handleComponentError}>
        <AboutModal />
    </svelte:boundary>
{:else if modalState.selected === "zoom"}
    <svelte:boundary onerror={handleComponentError}>
        <ZoomModal />
    </svelte:boundary>
{:else if modalState.selected === "eventGroupOptions"}
    <svelte:boundary onerror={handleComponentError}>
        <EventGroupOptionsModal />
    </svelte:boundary>
{:else if modalState.selected === "pasteAttributes"}
    <svelte:boundary onerror={handleComponentError}>
        <PasteAttributesModal />
    </svelte:boundary>
{:else if modalState.selected === "usage" && environment.online}
    <svelte:boundary onerror={handleComponentError}>
        <UsageModal />
    </svelte:boundary>
{:else if modalState.selected === "snapshotHistory" && environment.online}
    <svelte:boundary onerror={handleComponentError}>
        <SnapshotHistoryModal />
    </svelte:boundary>
{:else if modalState.selected === "aiTranscriptImport" && environment.online}
    <svelte:boundary onerror={handleComponentError}>
        <AiTranscriptImportModal />
    </svelte:boundary>
{:else if modalState.selected === "aiTranslationImport" && environment.online}
    <svelte:boundary onerror={handleComponentError}>
        <AiTranslationImportModal />
    </svelte:boundary>
{:else if modalState.selected === "audioDescriptionExport" && authState.ad && environment.online}
    <svelte:boundary onerror={handleComponentError}>
        <AudioDescriptionExportModal />
    </svelte:boundary>
{:else if modalState.selected === "audioDubbingExport" && authState.ad && environment.online}
    <svelte:boundary onerror={handleComponentError}>
        <AudioDubbingExportModal />
    </svelte:boundary>
{:else if modalState.selected === "audioEmbedExport" && authState.ad && environment.electron}
    <svelte:boundary onerror={handleComponentError}>
        <AudioEmbedExportModal />
    </svelte:boundary>
{:else if modalState.selected === "batchTranscription" && environment.online}
    <svelte:boundary onerror={handleComponentError}>
        <BatchTranscriptionModal />
    </svelte:boundary>
{:else if modalState.selected === "automaticTranscription" && environment.online}
    <svelte:boundary onerror={handleComponentError}>
        <AutomaticTranscriptionModal />
    </svelte:boundary>
{:else if modalState.selected === "automaticTranslation" && (authState.plan === "pro" || authState.plan === "enterprise") && environment.online}
    <svelte:boundary onerror={handleComponentError}>
        <AutomaticTranslationModal />
    </svelte:boundary>
{:else if modalState.selected === "automaticAd" && authState.ad && environment.electron && environment.online}
    <svelte:boundary onerror={handleComponentError}>
        <AutomaticAdModal />
    </svelte:boundary>
{:else if modalState.selected === "aiAdImport" && authState.ad && environment.online}
    <svelte:boundary onerror={handleComponentError}>
        <AiAdImportModal />
    </svelte:boundary>
{:else if modalState.selected === "automaticSceneDescriptions" && (authState.plan === 'pro' || authState.plan === 'enterprise') && environment.electron && environment.online}
    <svelte:boundary onerror={handleComponentError}>
        <AutomaticSceneDescriptionsModal />
    </svelte:boundary>
{:else if modalState.selected === "aiSceneDescriptionImport" && (authState.plan === 'pro' || authState.plan === 'enterprise') && environment.online}
    <svelte:boundary onerror={handleComponentError}>
        <AiSceneDescriptionImportModal />
    </svelte:boundary>
{:else if modalState.selected === "fileExport"}
    <svelte:boundary onerror={handleComponentError}>
        <FileExportModal />
    </svelte:boundary>
{:else if modalState.selected === "fileImport"}
    <svelte:boundary onerror={handleComponentError}>
        <FileImportModal />
    </svelte:boundary>
{:else if modalState.selected === "markerImport"}
    <svelte:boundary onerror={handleComponentError}>
        <MarkerImportModal />
    </svelte:boundary>
{:else if modalState.selected === "mediaImport"}
    <svelte:boundary onerror={handleComponentError}>
        <MediaImportModal />
    </svelte:boundary>
{:else if modalState.selected === "audioStems"}
    <svelte:boundary onerror={handleComponentError}>
        <AudioStemsModal />
    </svelte:boundary>
{:else if modalState.selected === "musicNotes"}
    <svelte:boundary onerror={handleComponentError}>
        <MusicNotesModal />
    </svelte:boundary>
{:else if modalState.selected === "insertSpeaker"}
    <svelte:boundary onerror={handleComponentError}>
        <InsertSpeakerModal />
    </svelte:boundary>
{:else if modalState.selected === "newEventGroup"}
    <svelte:boundary onerror={handleComponentError}>
        <NewEventGroupModal />
    </svelte:boundary>
{:else if modalState.selected === "editEventGroup"}
    <svelte:boundary onerror={handleComponentError}>
        <EditEventGroupModal />
    </svelte:boundary>
{:else if modalState.selected === "mergeEventGroup"}
    <svelte:boundary onerror={handleComponentError}>
        <MergeEventGroupModal />
    </svelte:boundary>
{:else if modalState.selected === "translationMerge"}
    <svelte:boundary onerror={handleComponentError}>
        <TranslationMergeModal />
    </svelte:boundary>
{:else if modalState.selected === "metadataMerge"}
    <svelte:boundary onerror={handleComponentError}>
        <MetadataMergeModal />
    </svelte:boundary>
{:else if modalState.selected === "segmentEventGroup"}
    <svelte:boundary onerror={handleComponentError}>
        <SegmentEventGroupModal />
    </svelte:boundary>
{:else if modalState.selected === "newProject"}
    <svelte:boundary onerror={handleComponentError}>
        <NewProjectModal />
    </svelte:boundary>
{:else if modalState.selected === "options"}
    <svelte:boundary onerror={handleComponentError}>
        <OptionsModal />
    </svelte:boundary>
{:else if modalState.selected === "plainTextImport"}
    <svelte:boundary onerror={handleComponentError}>
        <PlainTextImportModal />
    </svelte:boundary>
{:else if modalState.selected === "goToEvent"}
    <svelte:boundary onerror={handleComponentError}>
        <GoToEventModal />
    </svelte:boundary>
{:else if modalState.selected === "projectTimingSettings"}
    <svelte:boundary onerror={handleComponentError}>
        <ProjectTimingSettingsModal />
    </svelte:boundary>
{:else if modalState.selected === "convertTimecode"}
    <svelte:boundary onerror={handleComponentError}>
        <ConvertTimecodeModal />
    </svelte:boundary>
{:else if modalState.selected === "offlineActivation" && environment.online}
    <svelte:boundary onerror={handleComponentError}>
        <OfflineActivationModal />
    </svelte:boundary>
{:else if modalState.selected === "recentProjects"}
    <svelte:boundary onerror={handleComponentError}>
        <StorageExplorerModal recent={true} />
    </svelte:boundary>
{:else if modalState.selected === "batchSubtitleExport"}
    <svelte:boundary onerror={handleComponentError}>
        <BatchSubtitleExportModal />
    </svelte:boundary>
{:else if modalState.selected === "dialogueListExport"}
    <svelte:boundary onerror={handleComponentError}>
        <DialogueListExportModal />
    </svelte:boundary>
{:else if modalState.selected === "subtitleExport"}
    <svelte:boundary onerror={handleComponentError}>
        <SubtitleExportModal />
    </svelte:boundary>
{:else if modalState.selected === "embedCaptionsExport" && environment.online && authState.plan !== "starter"}
    <svelte:boundary onerror={handleComponentError}>
        <EmbedCaptionsExportModal />
    </svelte:boundary>
{:else if modalState.selected === "ccslExport"}
    <svelte:boundary onerror={handleComponentError}>
        <CcslExportModal />
    </svelte:boundary>
{:else if modalState.selected === "subtitleImport"}
    <svelte:boundary onerror={handleComponentError}>
        <SubtitleImportModal />
    </svelte:boundary>
{:else if modalState.selected === "translationImport"}
    <svelte:boundary onerror={handleComponentError}>
        <TranslationImportModal />
    </svelte:boundary>
{:else if modalState.selected === "tcOffset"}
    <svelte:boundary onerror={handleComponentError}>
        <TcOffsetModal />
    </svelte:boundary>
{:else if modalState.selected === "blankFrames"}
    <svelte:boundary onerror={handleComponentError}>
        <BlankFramesModal />
    </svelte:boundary>
{:else if modalState.selected === "snapToShotChanges"}
    <svelte:boundary onerror={handleComponentError}>
        <SnapToShotChangesModal />
    </svelte:boundary>
{:else if modalState.selected === "timeStretch"}
    <svelte:boundary onerror={handleComponentError}>
        <TimeStretchModal />
    </svelte:boundary>
{:else if modalState.selected === "transcriptExport"}
    <svelte:boundary onerror={handleComponentError}>
        <TranscriptExportModal />
    </svelte:boundary>
{:else if modalState.selected === "teamProjectImport" && environment.online}
    <svelte:boundary onerror={handleComponentError}>
        <TeamProjectImportModal />
    </svelte:boundary>
{:else if modalState.selected === "teamShare" && environment.online}
    <svelte:boundary onerror={handleComponentError}>
        <TeamShareModal />
    </svelte:boundary>
{:else if modalState.selected === "teamSync" && environment.online}
    <svelte:boundary onerror={handleComponentError}>
        <TeamSyncModal />
    </svelte:boundary>
{:else if modalState.selected === "eventGroupSync"}
    <svelte:boundary onerror={handleComponentError}>
        <EventGroupSyncModal />
    </svelte:boundary>
{:else if modalState.selected === "renderAudio" && (authState.ad || environment.adLicense) && (environment.online || environment.adLicense)}
    <svelte:boundary onerror={handleComponentError}>
        <RenderAudioModal />
    </svelte:boundary>
{:else if modalState.selected === "audioRecorder" && authState.ad && environment.online}
    <svelte:boundary onerror={handleComponentError}>
        <AudioRecorderModal />
    </svelte:boundary>
{:else if modalState.selected === "videoExport"}
    <svelte:boundary onerror={handleComponentError}>
        <VideoExportModal />
    </svelte:boundary>
{:else if modalState.selected === "imageExport" && environment.electron}
    <svelte:boundary onerror={handleComponentError}>
        <ImageExportModal />
    </svelte:boundary>
{:else if modalState.selected === "welcome"}
    <svelte:boundary onerror={handleComponentError}>
        <WelcomeModal />
    </svelte:boundary>
{:else if modalState.selected === "speakerManager"}
    <svelte:boundary onerror={handleComponentError}>
        <SpeakerManager />
    </svelte:boundary>
{:else if modalState.selected === "tagsManager"}
    <svelte:boundary onerror={handleComponentError}>
        <TagsManager />
    </svelte:boundary>
{:else if modalState.selected === "styleGuideManager"}
    <svelte:boundary onerror={handleComponentError}>
        <StyleGuideManager />
    </svelte:boundary>
{:else if modalState.selected === "removeSdh"}
    <svelte:boundary onerror={handleComponentError}>
        <RemoveSdhModal />
    </svelte:boundary>
{:else if modalState.selected === "autoFormat"}
    <svelte:boundary onerror={handleComponentError}>
        <AutoFormatModal />
    </svelte:boundary>
{:else if modalState.selected === "autoCorrectTiming"}
    <svelte:boundary onerror={handleComponentError}>
        <AutoCorrectTimingModal />
    </svelte:boundary>
{:else if modalState.selected === "timingAndSyncSettings"}
    <svelte:boundary onerror={handleComponentError}>
        <TimingAndSyncSettingsModal />
    </svelte:boundary>
{:else if modalState.selected === "liveCaptionSettings"}
    <svelte:boundary onerror={handleComponentError}>
        <LiveCaptionSettingsModal />
    </svelte:boundary>
{:else if modalState.selected === "captionStyle"}
    <svelte:boundary onerror={handleComponentError}>
        <CaptionStyleModal />
    </svelte:boundary>
{:else if modalState.selected === "captionPosition"}
    <svelte:boundary onerror={handleComponentError}>
        <CaptionPositionModal />
    </svelte:boundary>
{:else if modalState.selected === "copyTcFromGroup"}
    <svelte:boundary onerror={handleComponentError}>
        <CopyTcFromGroupModal />
    </svelte:boundary>
{:else if modalState.selected === "copyEventText"}
    <svelte:boundary onerror={handleComponentError}>
        <CopyEventTextModal />
    </svelte:boundary>
{:else if modalState.selected === "splitMultiviewGroup"}
    <svelte:boundary onerror={handleComponentError}>
        <SplitMultiviewGroupModal />
    </svelte:boundary>
{:else if modalState.selected === "storageExplorer" && environment.online}
    <svelte:boundary onerror={handleComponentError}>
        <StorageExplorerModal recent={false} />
    </svelte:boundary>
{:else if modalState.selected === "projectImport"}
    <svelte:boundary onerror={handleComponentError}>
        <ProjectImportModal />
    </svelte:boundary>
{:else if modalState.selected === "autoReplace"}
    <svelte:boundary onerror={handleComponentError}>
        <AutoReplaceModal />
    </svelte:boundary>
{:else if modalState.selected === "teamManager" && environment.online}
    <svelte:boundary onerror={handleComponentError}>
        <TeamManagerModal />
    </svelte:boundary>
{:else if modalState.selected === "presetManager"}
    <svelte:boundary onerror={handleComponentError}>
        <PresetManagerModal />
    </svelte:boundary>
{:else if modalState.selected === "tips"}
    <svelte:boundary onerror={handleComponentError}>
        <TipsModal />
    </svelte:boundary>
{:else if modalState.selected === "voiceManager" && canUseAudioDescription}
    <svelte:boundary onerror={handleComponentError}>
        <VoiceManagerModal />
    </svelte:boundary>
{:else if modalState.selected === "eventGroupMetadata"}
    <svelte:boundary onerror={handleComponentError}>
        <EventGroupMetadataModal />
    </svelte:boundary>
{:else if modalState.selected === "sceneChangeDetection" && environment.electron}
    <svelte:boundary onerror={handleComponentError}>
        <SceneChangeDetectionModal />
    </svelte:boundary>
{:else if modalState.selected === "preRenderFrameCache" && environment.electron}
    <svelte:boundary onerror={handleComponentError}>
        <PreRenderFrameCacheModal />
    </svelte:boundary>
{:else if modalState.selected === "offlineTranscription" && environment.electron}
    <svelte:boundary onerror={handleComponentError}>
        <OfflineTranscriptionModal />
    </svelte:boundary>
{:else if modalState.selected === "offlineSync" && environment.electron}
    <svelte:boundary onerror={handleComponentError}>
        <OfflineSyncModal />
    </svelte:boundary>
{:else if modalState.selected === "ocrMedia" && environment.electron}
    <svelte:boundary onerror={handleComponentError}>
        <OcrMediaModal />
    </svelte:boundary>
{:else if modalState.selected === "openInDesktop" && environment.online && !environment.electron && !environment.iframe}
    <svelte:boundary onerror={handleComponentError}>
        <OpenInDesktopModal />
    </svelte:boundary>
{:else if modalState.selected === "iconikImport" && environment.online}
    <svelte:boundary onerror={handleComponentError}>
        <IconikImportModal />
    </svelte:boundary>
{:else if modalState.selected === "iconikGetProxy" && environment.online}
    <svelte:boundary onerror={handleComponentError}>
        <IconikGetProxyModal />
    </svelte:boundary>
{:else if modalState.selected === "iconikPublish" && environment.online}
    <svelte:boundary onerror={handleComponentError}>
        <IconikPublishModal />
    </svelte:boundary>
{:else if modalState.selected === "iconikMetadata" && environment.online}
    <svelte:boundary onerror={handleComponentError}>
        <IconikMetadataModal />
    </svelte:boundary>
{:else if modalState.selected === "workOrderImport" && environment.online}
    <svelte:boundary onerror={handleComponentError}>
        <WorkOrderImportModal />
    </svelte:boundary>
{:else if modalState.selected === "workOrderPublish" && environment.online}
    <svelte:boundary onerror={handleComponentError}>
        <WorkOrderPublishModal />
    </svelte:boundary>
{:else if modalState.selected === "loadProjectFile"}
    <svelte:boundary onerror={handleComponentError}>
        <LoadProjectFileModal {projectFilePath} />
    </svelte:boundary>
{:else if modalState.selected === "drasticTech" && environment.electron}
    <svelte:boundary onerror={handleComponentError}>
        <DrasticTechModal />
    </svelte:boundary>
{:else if modalState.selected === "projectInfo"}
    <svelte:boundary onerror={handleComponentError}>
        <ProjectInfoModal />
    </svelte:boundary>
{:else if modalState.selected === "compareEventGroups"}
    <svelte:boundary onerror={handleComponentError}>
        <CompareEventGroupsModal />
    </svelte:boundary>
{:else if modalState.selected === "knpManager"}
    <svelte:boundary onerror={handleComponentError}>
        <KnpManager />
    </svelte:boundary>
{:else if modalState.selected === "subscriptionManagement" && environment.online}
    <svelte:boundary onerror={handleComponentError}>
        <SubscriptionManagement />
    </svelte:boundary>
{/if}

{#if uiState.knpLookup && environment.online && !modalState.selected}
    <svelte:boundary onerror={handleComponentError}>
        <KnpLookup/>
    </svelte:boundary>
{/if}